import { render, staticRenderFns } from "./PlaceManagement.vue?vue&type=template&id=b8af616a&scoped=true&"
import script from "./PlaceManagement.vue?vue&type=script&lang=js&"
export * from "./PlaceManagement.vue?vue&type=script&lang=js&"
import style0 from "./PlaceManagement.vue?vue&type=style&index=0&id=b8af616a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8af616a",
  null
  
)

export default component.exports